import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class IconSwitcherAPI extends ComponentAPI {
    getFallbackIcon() {
        return this.state.fallbackIcon;
    }
    setFallbackIcon(fallbackIcon) {
        this.setState({ fallbackIcon });
    }
    /**
     * Returns the current set of icons being matched against the component value.
     */
    getIcons() {
        return this.state.icons;
    }
    /**
     * Updates the current set of icons being matched against the component value.
     *
     * @param icons - The new set of icons to be used.
     */
    setIcons(icons) {
        this.setState({ icons });
    }
    /**
     * Returns if the label and icon positions are reversed.
     */
    getReverse() {
        return Boolean(this.state.reverse);
    }
    /**
     * Updates the reverse state of the component.
     *
     * @param reverse - The new reverse status of the component.
     */
    setReverse(reverse) {
        this.setState({ reverse });
    }
    /**
     * Returns the current component size.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Updates the rendered icon size.
     *
     * @param size - The new icon size.
     */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Returns the current component value.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Updates the component value, with the possibility of a new icon being shown.
     *
     * @param value - The new component value.
     */
    setValue(value) {
        this.setState({ value });
    }
}
export { IconSwitcherAPI, };
//# sourceMappingURL=icon-switcher-api.js.map